import { createContext, useContext, useEffect, useRef, useState } from 'react';

import { RetryPaymentStatus } from '../../types';

export type RetryPaymentInfo = {
  retryPossible: boolean;
  retryPaymentStatus?: RetryPaymentStatus;
};

export type AppContextData = {
  setRetryPaymentInfo: (retryPaymentInfos: RetryPaymentInfo) => void;
  retryPaymentInfo: RetryPaymentInfo;
};

const RetryPaymentContext = createContext<AppContextData>({
  setRetryPaymentInfo: () => {},
  retryPaymentInfo: {
    retryPossible: true,
  },
});

export const useRetryPaymentContext = () => {
  const context = useContext(RetryPaymentContext);
  return context;
};

export type RetryPaymentContextProviderProps = {
  retryPossible: boolean;
  retryPaymentStatus?: RetryPaymentStatus;
};

const RetryPaymentContextProvider: React.FC<RetryPaymentContextProviderProps> = ({
  children,
  retryPossible: retryPossibleInit,
  retryPaymentStatus: retryPaymentStatusInit,
}) => {
  const [retryPaymentInfo, setRetryPaymentInfo] = useState<RetryPaymentInfo>({
    retryPossible: retryPossibleInit,
    retryPaymentStatus: retryPaymentStatusInit,
  });

  const firstRender = useRef(true);
  useEffect(() => {
    if (!firstRender.current) {
      setRetryPaymentInfo({
        retryPossible: retryPossibleInit,
        retryPaymentStatus: retryPaymentStatusInit,
      });
    }
    firstRender.current = false;
  }, [retryPossibleInit, retryPaymentStatusInit]);

  return (
    <RetryPaymentContext.Provider
      value={{
        retryPaymentInfo,
        setRetryPaymentInfo,
      }}>
      {children}
    </RetryPaymentContext.Provider>
  );
};

export default RetryPaymentContextProvider;
